<template>
    <div class="container">
        <cardHead title="活畜概况" />
        <div class="number">
            <div class="hc-num">羊只总数</div>
            <ul style="margin-left: .25rem;">
                <li v-for="(item, i) in numberList" :key="i">
                    {{ item }}
                </li>
            </ul>
        </div>
        <div class="number" style="margin-top: .5rem;">
            <div class="hc-num">产绒量(kg)</div>
            <ul style="margin-left: .1rem;">
                <li v-for="(item, i) in numberList1" :key="i" :class="{ round: item == '.' }">
                    {{ item }}
                </li>
            </ul>
        </div>
        <div class="info">
            <dv-active-ring-chart :config="config" style="width:3rem;height:3rem" />
            <div class="info-r">
                <div class="line">
                    <span>种公羊</span>
                    <span style="margin-left: 0.25rem;">7.5%</span>
                    <span style="margin-left: 0.1rem;">120只</span>
                    <!-- <span class="el-icon-arrow-right" style="cursor: pointer;"></span> -->
                </div>
                <div class="line" style="margin-top: .25rem;">
                    <span>基础母羊</span>
                    <span style="margin-left: 0.1rem;">40.6%</span>
                    <span style="margin-left: 0.1rem;">650只</span>
                    <!-- <span class="el-icon-arrow-right" style="cursor: pointer;"></span> -->
                </div>
                <div class="line" style="margin-top: .25rem;">
                    <span>其他</span>
                    <span style="margin-left: 0.4rem;">51%</span>
                    <span style="margin-left: 0.15rem;">830只</span>
                    <!-- <span class="el-icon-arrow-right" style="cursor: pointer;margin-left: 0.15rem;"></span> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cardHead from './cardHead.vue'
export default {

    props: {
        title: {
            type: String,
            default: '',
        },

    },
    components: {
        cardHead
    },
    data() {
        return {
            numberList: [1, 6, 0, 0],
            numberList1: [8, 2, 5, '.', 6],
            config: {
                radius: '40%',
                activeRadius: '45%',
                data: [
                    {
                        name: '种公羊',
                        value: 120
                    },
                    {
                        name: '基础母羊',
                        value: 650
                    },
                    {
                        name: '其他',
                        value: 830
                    }
                ],
                digitalFlopStyle: {
                    fontSize: 20
                },
                showOriginValue: true
            }
        };
    },
    async created() {

    },

    methods: {



    },
};
</script>
<style lang="scss" scoped>
.container {
    width: 5rem;
    height: 5.63rem;
    background: url('../../../assets/yq/rectangle.png');
    background-size: 100% 100%;

    .number {
        display: flex;
        align-items: center;
        margin-left: .18rem;
        margin-top: .38rem;

        .hc-num {
            font-size: 0.18rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
        }

        ul {
            display: flex;

            li {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: .13rem;
                width: 0.44rem;
                height: 0.44rem;
                background: rgba(0, 254, 255, 0.12);
                box-shadow: inset 0rem 0rem 0.08rem 0rem rgba(0, 224, 219, 0.2);
                border-radius: 0rem 0rem 0rem 0rem;
                opacity: 1;
                border: 0.01rem solid rgba(0, 254, 255, 0.102);
                font-size: 0.33rem;
                font-family: Impact-Regular, Impact;
                font-weight: 400;
                color: #00FEFF;
            }
        }
    }

    .round {
        width: 0.15rem !important;
        height: 0.6rem !important;
        background: none !important;
        box-shadow: none !important;
        border: none !important;
    }

    .info {
        display: flex;
        align-items: center;

        .info-r {
            display: flex;
            flex-direction: column;
            margin-left: -0.45rem;

            .line {
                width: 2.5rem;
                height: 0.29rem;
                line-height: .29rem;
                // background: url('../../../assets/yq/line.png');
                // background-size: 100% 100%;

                span {
                    font-size: 0.15rem;
                    font-family: Source Han Sans-Regular, Source Han Sans;
                    font-weight: 400;
                    color: #47FFFF;
                    text-align: center;
                    margin-left: .2rem;

                    &:nth-child(4) {
                        color: #FFF200;
                    }
                }
            }
        }
    }
}
</style>